/** Support threads as hg-content's staff endpoints give them (`../hg-content/openapi.json`). */
import type { components } from "@/shared/api/content.schema";

type Schemas = components["schemas"];

export type Thread = Schemas["AdminThreadResponse"];
export type Message = Schemas["AdminMessageResponse"];
export type ThreadCounts = Schemas["ThreadCountsResponse"];
/** The app a thread's owner writes from: somebody who is both has a thread on each side. */
export type Side = Thread["side"];

export const SIDES = ["client", "specialist"] as const satisfies readonly Side[];

/** The pictures a message may carry, as hg-content takes them. */
export const PICTURE_TYPES = ["image/jpeg", "image/png", "image/webp"] as const;
/** The largest picture hg-content takes. */
export const PICTURE_MAX_BYTES = 10 * 1024 * 1024;
/** The longest a message's words may be. */
export const MAX_WORDS = 4_000;
